import LanguageSwitcher from "@/components/ui/LanguageSwitcher";
import { Link, useLocation } from "react-router-dom";

/**
 * Shared public navigation bar used on Landing Page, Blog, FAQ, etc.
 * Mirrors the LandingPage nav with active-state highlights.
 */
export function PublicNav() {
  const { pathname } = useLocation();

  const navLinks = [
    { label: "Features", href: "/#features", isAnchor: true },
    { label: "How it Works", href: "/#how-it-works", isAnchor: true },
    { label: "Pricing", href: "/#pricing", isAnchor: true },
    { label: "Blog", href: "/blog", isAnchor: false },
    { label: "FAQ", href: "/faq", isAnchor: false },
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm border-b border-gray-200 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center shrink-0">
            {/* shrink-0, or a narrow header squashes the mark: the height is
                fixed, so the only thing left to give is width, and the round
                dots turn into ovals. */}
            <img
              src="/images/healthpass_logo.png"
              alt="HealthPass Logo"
              className="h-8 w-auto shrink-0 object-contain sm:h-10"
            />
          </Link>

          {/* Center links – hidden on mobile */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) =>
              link.isAnchor ? (
                <a
                  key={link.label}
                  href={link.href}
                  className="text-gray-700 hover:text-blue-600 transition text-sm font-medium"
                >
                  {link.label}
                </a>
              ) : (
                <Link
                  key={link.label}
                  to={link.href}
                  className={`text-sm font-medium transition ${
                    pathname.startsWith(link.href)
                      ? "text-blue-600"
                      : "text-gray-700 hover:text-blue-600"
                  }`}
                >
                  {link.label}
                </Link>
              ),
            )}
          </div>

          {/* Right side */}
          <div className="flex items-center space-x-4">
            <LanguageSwitcher />
            <Link
              to="/traveler/login"
              className="text-gray-700 hover:text-blue-600 transition font-medium h-10 flex items-center whitespace-nowrap text-sm"
            >
              Login
            </Link>
            <Link
              to="/traveler/register"
              className="bg-blue-600 text-white px-6 h-10 flex items-center rounded-lg hover:bg-blue-700 transition font-medium whitespace-nowrap text-sm"
            >
              Sign Up
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
